// import React from "react";
import bg from "../../assets/images/10002.jpg";
import img1 from "../../assets/images/10003.png";
import { FaLaptopHouse, FaRegListAlt, FaUsers } from "react-icons/fa";
import { GrAchievement } from "react-icons/gr";
function FavoritePlace() {
  return (
    <div
      className="text-hiberet-primary bg-opacity-75 space-y-6 flex flex-col mt-7 h-full px-14 py-20 relative"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Black overlay for the image */}
      <div className="absolute inset-0 bg-black opacity-50 pointer-events-none"></div>

      <div className="relative flex-wrap flex justify-between space-y-4 w-full my-28">
        <div className="flex items-center gap-3 w-1/2">
          <div className="space-y-4">
            <h1 className="text-white font-bold text-5xl">
              Find Your Favorite Traveling Place
            </h1>
            <p className="text-white w-1/2">
              pe earum totam minima aperiam repellendus possimus molestias optio
              sapiente, quam repudiandae voluptatum accusantium.
            </p>
            <button className="bg-primary text-white font-semibold py-2 px-6 rounded-lg shadow-lg hover:bg-blend-multiply transition-all transform hover:scale-105">
              Register Now
            </button>
          </div>
        </div>

        <div className="flex items-center gap-3 w-1/2">
          <img src={img1} alt="" />
        </div>
      </div>
    </div>
  );
}

export default FavoritePlace;
